import { render, staticRenderFns } from "./noSysTake.vue?vue&type=template&id=08028f92&scoped=true&"
import script from "./noSysTake.vue?vue&type=script&lang=js&"
export * from "./noSysTake.vue?vue&type=script&lang=js&"
import style0 from "./noSysTake.vue?vue&type=style&index=0&id=08028f92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08028f92",
  null
  
)

export default component.exports